/**
 * First we will load all of this project's JavaScript dependencies which
 * includes Vue and other libraries. It is a great starting point when
 * building robust, powerful web applications using Vue and Laravel.
 */

import './bootstrap'
import Vue from 'vue'

/**
 * Font Awesome Icons
 */

import { library } from '@fortawesome/fontawesome-svg-core'
import { fas } from '@fortawesome/pro-solid-svg-icons'
import { far } from '@fortawesome/pro-regular-svg-icons'
import { fal } from '@fortawesome/pro-light-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import Helper from './plugins/Helper.js'

library.add(fas, far, fal)

Vue.component('font-awesome-icon', FontAwesomeIcon)

/**
 * Datepicker
 */

import Datepicker from 'vuejs-datepicker'

Vue.component('datepicker', Datepicker)

/**
 * jQuery Init
 */

$(function () {
	$('[data-toggle="tooltip"]').tooltip()
})

/**
 * Sentry
 */
import * as Sentry from '@sentry/vue'

Sentry.init({
	Vue,
	dsn: 'https://364bf8e033334f07a89d0895d36872e5@o390742.ingest.sentry.io/5312311',
	integrations: [],
	// Set tracesSampleRate to 1.0 to capture 100%
	// of transactions for performance monitoring.
	// We recommend adjusting this value in production
	tracesSampleRate: 1.0,
})

/**
 * The following block of code may be used to automatically register your
 * Vue components. It will recursively scan this directory for the Vue
 * components and automatically register them with their "basename".
 *
 * Eg. ./components/ExampleComponent.vue -> <example-component></example-component>
 */

const files = require.context('./', true, /\.vue$/i)
files.keys().map((key) => Vue.component(key.split('/').pop().split('.')[0], files(key).default))

/**
 * Next, we will create a fresh Vue application instance and attach it to
 * the page. Then, you may begin adding components to this application
 * or customize the JavaScript scaffolding to fit your unique needs.
 */

Vue.use(Helper)
Vue.directive('click-outside', {
	bind: function (el, binding, vnode) {
		el.clickOutsideEvent = function (event) {
			// here I check that click was outside the el and his childrens
			if (!(el == event.target || el.contains(event.target))) {
				// and if it did, call method provided in attribute value
				vnode.context[binding.expression](event)
			}
		}
		document.body.addEventListener('click', el.clickOutsideEvent)
	},
	unbind: function (el) {
		document.body.removeEventListener('click', el.clickOutsideEvent)
	},
})

const app = new Vue({
	el: '#root',
	data: {
		asideCompressed: true,
		asideHover: false,
		requestHeaders: {
			Accept: 'application/json; charset=utf-8',
			'Content-Type': 'application/json; charset=utf-8; boundary=something',
			//'enctype': 'multipart/form-data',
		},
	},
	mounted: function () {
		this.$refs['rootLoader'].hide()
	},
	methods: {
		showModalStep: function (step) {
			this.$refs.step_modal.open(step, false)
		},
		showModalStepThx: function (step) {
			this.$refs.step_modal.open(step, true)
		},
		//
		showModal: function (modalName) {
			this.$refs[modalName].open()
		},
		showModalWithData: function (modalName, datas) {
			this.$refs[modalName].open(datas)
		},
		toogleAside: function () {
			this.asideCompressed = !!this.asideCompressed ? false : true
		},
		toogleAsideHover: function () {
			this.asideHover = !!this.asideHover ? false : true
		},
		request: function (that, url, method, params, callback, customHeaders) {
			if (!method) method = 'GET'

			var new_headers = { ...this.requestHeaders, ...customHeaders }
			return axios({
				url: url,
				method: method.toUpperCase(),
				data: !!params ? params : {},
				headers: new_headers,
			})
				.then(({ data, status, statusText }) => {
					if (typeof callback === 'function') return callback.apply(that, [data])
				})
				.catch(({ response, request, message, config }) => {
					return false
				})
		},

		requestGet: function (that, url, callback) {
			return this.request(that, url, 'GET', {}, callback)
		},
		requestPost: function (that, url, params, callback) {
			return this.request(that, url, 'POST', params, callback)
		},
		requestPatch: function (that, url, params, callback) {
			return this.request(that, url, 'PATCH', params, callback)
		},
		requestDelete: function (that, url, callback) {
			if (!!confirm("Sei sicuro? L'operazione non è reversibile."))
				return this.request(that, url, 'DELETE', {}, callback)
		},
		getParamsFromForm: function (formEl) {
			let params = {}

			let formData = new FormData(formEl)
			formData.forEach((value, key) => {
				params[key] = value
			})

			return params
		},
		getParamsFromDiv: function (divEl) {
			let params = {}
			let elements = divEl.querySelectorAll('input, select, textarea')

			elements.forEach((value, key) => {
				let selectorName = false

				switch (value.tagName.toUpperCase()) {
					case 'INPUT':
						selectorName = value.tagName.toUpperCase() + '.' + value.type.toUpperCase()
						break
					default:
						selectorName = value.tagName.toUpperCase()
				}

				switch (selectorName) {
					case 'INPUT.CHECKBOX':
						let checkedArrCheck = []

						document.getElementsByName(value.name).forEach((element2) => {
							if (!!element2.checked) {
								checkedArrCheck.push(element2.value.toString())
							}
						})

						params[value.name] = !!checkedArrCheck ? checkedArrCheck : ''
						break
					case 'INPUT.RADIO':
						let checkedArrRad = ''

						document.getElementsByName(value.name).forEach((element2) => {
							if (!!element2.checked) {
								checkedArrRad = element2.value.toString()
							}
						})

						params[value.name] = checkedArrRad
						break
					default:
						params[value.name] = value.value.toString()
				}
			})

			return params
		},
		resetsFromDiv: function (divEl) {
			let elements = divEl.querySelectorAll('input, select, textarea')

			elements.forEach((value, key) => {
				let selectorName = false

				switch (value.tagName.toUpperCase()) {
					case 'INPUT':
						selectorName = value.tagName.toUpperCase() + '.' + value.type.toUpperCase()
						break
					default:
						selectorName = value.tagName.toUpperCase()
				}

				switch (selectorName) {
					case 'INPUT.CHECKBOX':
						document.getElementsByName(value.name).forEach((element2) => {
							if (!!element2.checked) {
								element2.checked = false
							}
						})
						break
					case 'INPUT.RADIO':
						document.getElementsByName(value.name).forEach((element2) => {
							if (!!element2.checked) {
								element2.checked = false
							}
						})
						break
					default:
						value.value = ''
				}
			})

			return true
		},
		submitForm: function (id) {
			document.getElementById(id).click()
		},
		tableRefresh: function (table, related) {
			if (typeof related === 'undefined') related = false

			this.$refs[table].refreshTable(related)
		},
		filterTableContains: function (table, field, value) {
			this.$refs[table].filterContains(field, value)
		},
		filterTableEquals: function (table, field, value) {
			this.$refs[table].filterEquals(field, value)
		},
		filterTableDateFrom: function (table, field, value) {
			this.$refs[table].filterDateFrom(field, value)
		},
		filterTableDateTo: function (table, field, value) {
			this.$refs[table].filterDateTo(field, value)
		},
		filterTable: function (table, filters) {
			this.$refs[table].setFilters(filters)
		},
		formatFileTableCell: function (item, row, meta) {
			if (!!item) return "<a href=' " + item.url + " '>" + item.filename + '</a>'
			else return ''
		},
		formatBoolTableCell: function (item, row, meta) {
			if (!!item && item != false) return 'Si'
			else return 'No'
		},
		formatDefaultTypeTableCell: function (item, row, meta) {
			switch (item) {
				case 2:
					return 'Annuale'
					break
				case 1:
					return 'Mensile'
					break
				case 0:
					return 'OneOff'
					break
				default:
					return ''
					break
			}
		},
		reload: function () {
			window.location.reload(true)
		},
	},
})
